


















































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'Question527',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
        language: 'fr',
      },
    };
  },
  computed: {
    imageName(): string {
      return prefixPublicAsset('/img/assignments/q528_main.png');
    },
    imageAName(): string {
      return prefixPublicAsset('/img/assignments/q528_choiceA.png');
    },
    imageBName(): string {
      return prefixPublicAsset('/img/assignments/q528_choiceB.png');
    },
    imageCName(): string {
      return prefixPublicAsset('/img/assignments/q528_choiceC.png');
    },
  },
};
